import { render, staticRenderFns } from "./DoorHasWindow.vue?vue&type=template&id=03459d47"
import script from "./DoorHasWindow.vue?vue&type=script&lang=ts"
export * from "./DoorHasWindow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports